module.exports = __webpack_public_path__ + "static/media/user.e2a18523.png";